<template>
  <select @change="switchLanguage">
    <option
        v-for="sLocale in supportedLocales"
        :key="`locale-${sLocale}`"
        :value="sLocale"
        :selected="locale === sLocale"
    >
      {{ t(`locale.${sLocale}`) }}
    </option>
  </select>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from "vue-router"
import Tr from "@/i18n/translation"
import {User, type UserData} from "@/types/users/user";
import {useAuthStore} from "@/stores/auth";
import {useApiStore} from "@/stores/api";

const { t, locale } = useI18n()
const supportedLocales = Tr.supportedLocales
const router = useRouter()
const authStore = useAuthStore();
const api = useApiStore();

const switchLanguage = async (event) => {
  const newLocale = event.target.value
  await Tr.switchLanguage(newLocale)
  try {
    await router.replace({ params: { locale: newLocale } })
  } catch(e) {
    console.log(e)
    router.push("/")
  }

  updateLanguage();
}

const updateLanguage = () => {
  if(authStore.user === null)
  {
    return;
  }

  let languagePatch=Tr.currentLocale;
  const payload = {
    id: authStore.user.id,
    language:languagePatch.toString(),
  }
  console.log(payload)

  api.saveItem<User, UserData>('users', authStore.user.id , payload , User).then(() => {

  });

}
</script>
